// src/routes/AppRouter.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { useAppSelector } from "../hooks/hooks"; // Adjust the path to your `hooks.ts` file
import LoginModal from "../components/AuthModals/LoginModal";
import SignUpModal from "../components/AuthModals/SignUpModal";
import ForgotPasswordModal from "../components/AuthModals/ResetPasswordModal";
import ResetPasswordResponseModal from "../components/AuthModals/ResetPasswordResponseModal";
import NewPasswordModal from "../components/AuthModals/NewPasswordModal";
import Homepage from "../pages/Homepage";
import ViewAll from "../pages/Homepage/ViewAll";
import Account from "../pages/Account";

// import Profile from "../pages/Profile";
import Navbar from "../components/Navbar";
import Data from "../pages/Products/Data";
import Prepaid from "../pages/Products/Data";
import Airtime from "../pages/Products/Airtime";
import Electricity from "../pages/Products/Electricity";
import Cart from "../pages/Cart";
import Support from "../pages/Support";
import SearchResults from "../pages/SearchResults";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>{children}</main>
      {/* <LoginModal /> */}
      {/* Global Modals */}
      <LoginModal />
           <SignUpModal />
           <ForgotPasswordModal />
           <ResetPasswordResponseModal />
           <NewPasswordModal />
    </div>
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAppSelector((state) => state.auth);
  return user ? <>{children}</> : <Navigate to="/" />;
};

const ProtectedRoutes = () => (
  <Routes>
    <Route path="" element={<Account />} />
    {/* <Route path="*" element={<NotFound />} /> */}
  </Routes>
);

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Homepage />} />

          <Route path="/cart" element={<Cart />} />
          {/*Used for testing purpose*/}
          <Route path="/account" element={<Account />} />
          <Route
            path="/account/*"
            element={
              <ProtectedRoute>
                <ProtectedRoutes />
              </ProtectedRoute>
            }
          />

          <Route path="/products">
            <Route path="data/*" element={<Data />} />
            <Route path="prepaid/*" element={<Prepaid />} />
            <Route path="airtime/*" element={<Airtime />} />
            <Route path="electric/*" element={<Electricity />} />
          </Route>
          <Route path="/view-all/*" element={<ViewAll />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/support" element={<Support />} />
          {/* Resolve The 2 routes below*/}
          {/* <Route path="/profile" element={<Profile />} /> */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </Layout>
    </Router>
  );
};

export default AppRouter;
